export const pricingWithAutomation = ['Pricing2018UnlimitedPro', 'Pricing2020UnlimitedPro', 'Pricing2021UnlimitedPro'];
